import RecentSearchItem from "./recent-search-item"
import { LinkBtn } from "../buttons"
import { SearchResult } from "../../../types"
import { MutableRefObject } from "react"

interface Props {
  recentSearches: SearchResult[]
  onClickItem: (result: SearchResult) => void
  onClickResetRecentSearches: () => void
  itemRefs: MutableRefObject<(HTMLDivElement | null)[]>
  activeIndex: number
  onItemKeyDown: (e: React.KeyboardEvent, index: number) => void
}

const RecentSearches = ({
  recentSearches,
  onClickItem,
  onClickResetRecentSearches,
  itemRefs,
  activeIndex,
  onItemKeyDown
}: Props) => {
  const handleClearKeyDown = (
    e: React.KeyboardEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onClickResetRecentSearches()
    } else {
      // Pass other keys (like arrows) to the parent handler
      onItemKeyDown(e as any, 0)
    }
  }

  return (
    <div className="p-2">
      <div className="flex items-center justify-between px-3 pt-1 pb-2 text-xs font-semibold text-neutral-400">
        <span>Recent searches</span>
        {recentSearches.length > 0 && (
          <LinkBtn
            refProp={el => (itemRefs.current[0] = el as any)}
            type="button"
            className="!p-0 text-xs focus:ring-offset-2"
            onClick={onClickResetRecentSearches}
            onKeyDown={handleClearKeyDown}
          >
            Clear
          </LinkBtn>
        )}
      </div>
      {recentSearches.length ? (
        recentSearches.map((result, idx) => (
          <RecentSearchItem
            key={result.id}
            ref={el => (itemRefs.current[idx + 1] = el)}
            data={result}
            isActive={activeIndex === idx + 1}
            onClickItem={onClickItem}
            onKeyDown={e => onItemKeyDown(e, idx + 1)}
          />
        ))
      ) : (
        <div className="px-3 py-6 text-sm text-neutral-400">
          Search by name, email, NMLS or ID — results you open show up here.
        </div>
      )}
    </div>
  )
}

export default RecentSearches
